var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"md":"12"}},[_c('CCard',[_c('CCardHeader',[_vm._v(" Setting ( This page has not been developed.) ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }